module.exports = __webpack_public_path__ + "static/media/Ensure-Family.d50918eb.png";